import { motion } from "framer-motion";
import SectionHead from "@/components/SectionHead";
import { stats } from "@/data/content";

const Composition = () => (
  <div className="relative flex items-center justify-center h-72 sm:h-96" aria-hidden>
    <motion.svg
      viewBox="0 0 200 200"
      className="absolute w-56 h-56 sm:w-80 sm:h-80 text-turq/25"
      fill="none"
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 60, ease: "linear" }}
    >
      <polygon points="100 6 181.5 51 181.5 149 100 194 18.5 149 18.5 51" stroke="currentColor" strokeWidth="1" />
      <polygon points="100 26 163.8 61.6 163.8 138.4 100 174 36.2 138.4 36.2 61.6" stroke="currentColor" strokeWidth="0.6" opacity="0.6" />
    </motion.svg>
    <motion.span
      animate={{ y: [0, -12, 0] }}
      transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
      className="relative font-syne font-extrabold text-[10rem] sm:text-[14rem] leading-none text-slate-100 select-none"
    >
      <span className="text-gradient">i</span>
    </motion.span>
    <motion.div
      animate={{ y: [0, -18, 0], rotate: [0, 8, 0] }}
      transition={{ repeat: Infinity, duration: 6, ease: "easeInOut", delay: 0.6 }}
      className="absolute top-4 right-6 sm:top-10 sm:right-16 w-10 h-10 hex-clip bg-amberx/80"
    />
    <motion.div
      animate={{ y: [0, 14, 0] }}
      transition={{ repeat: Infinity, duration: 7, ease: "easeInOut", delay: 1 }}
      className="absolute bottom-6 left-4 sm:bottom-12 sm:left-14 w-8 h-8 hex-clip bg-eblue/70"
    />
  </div>
);

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div>
          <SectionHead eyebrow="About Us" title="Content Partnership" testId="about-title" />
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="space-y-5 text-slate-300 text-base md:text-lg leading-relaxed max-w-xl"
          >
            <p>
              We're more than just a content creator — we manage an eco-system around TV, digital
              partnerships and social media projects.
            </p>
            <p>
              Beyond creating content, we bridge brand's message with the content, thru the perfect
              TV &amp; digital platform partnerships, fostering a powerful connection with your audience.
            </p>
            <p className="text-slate-400">
              Our mission is to execute this vision seamlessly, generating organic growth and value
              for both your brand and the content universe as a whole.
            </p>
          </motion.div>

          <div className="mt-12 grid grid-cols-3 gap-6">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 + i * 0.12 }}
              >
                <p className="font-syne text-2xl sm:text-4xl font-bold text-gradient">{s.value}</p>
                <p className="mt-2 text-[11px] sm:text-xs uppercase tracking-[0.2em] text-slate-500">{s.label}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <Composition />
      </div>
    </section>
  );
}
